import React, { useRef, useState, useCallback } from 'react';
import './joystick.scss';

const MAX_RADIUS = 42; // px — حداکثر فاصله‌ای که دسته می‌تواند از مرکز پایه فاصله بگیرد

// جوی‌استیک لمسی برای حرکت در حالت اول‌شخص — کاملاً دستی و بدون کتابخانه‌ی خارجی (برای این‌که به
// وابستگی جدید نیاز نباشد)، مقدار خروجی {x, y} همیشه بین -1 و 1 است. y=1 یعنی «جلو»
function Joystick({ onChange, onRelease }) {
  const baseRef = useRef(null);
  const activePointerId = useRef(null);
  const [knob, setKnob] = useState({ x: 0, y: 0 });

  const updateFromEvent = useCallback(
    (e) => {
      const base = baseRef.current;
      if (!base) return;
      const rect = base.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      let dx = e.clientX - cx;
      let dy = e.clientY - cy;
      const dist = Math.hypot(dx, dy);
      if (dist > MAX_RADIUS) {
        dx = (dx / dist) * MAX_RADIUS;
        dy = (dy / dist) * MAX_RADIUS;
      }
      setKnob({ x: dx, y: dy });
      // y صفحه رو به پایین مثبت است؛ برای این‌که «بالا بردن انگشت = جلو رفتن» باشد علامتش را برمی‌گردانیم
      onChange({ x: dx / MAX_RADIUS, y: -dy / MAX_RADIUS });
    },
    [onChange]
  );

  const handlePointerDown = (e) => {
    e.preventDefault();
    activePointerId.current = e.pointerId;
    e.currentTarget.setPointerCapture(e.pointerId);
    updateFromEvent(e);
  };

  const handlePointerMove = (e) => {
    if (activePointerId.current !== e.pointerId) return;
    updateFromEvent(e);
  };

  const endTouch = (e) => {
    if (activePointerId.current !== e.pointerId) return;
    activePointerId.current = null;
    setKnob({ x: 0, y: 0 });
    onRelease();
  };

  return (
    <div
      ref={baseRef}
      className="joystick"
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={endTouch}
      onPointerCancel={endTouch}
    >
      <div className="joystick__knob" style={{ transform: `translate(${knob.x}px, ${knob.y}px)` }} />
    </div>
  );
}

export default Joystick;